module.exports = __webpack_public_path__ + "static/img/liBgImage2-hover.a664831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/technicalAdvantages/liBgImage2-hover.png
// module id = l8/F
// module chunks = 7